import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AppApis } from '@app/core/APIs/app-apis';
import type {
  WorkflowAutomatedActivitiesRead,
  WorkflowAutomatedActivityRun,
} from './workflow-automated-activities.models';
const headers = new HttpHeaders({
  'skip-error-interceptor': 'yes',
  'skip-loading-interceptor': 'yes',
});
@Injectable({ providedIn: 'root' })
export class WorkflowAutomatedActivitiesService {
  private readonly http = inject(HttpClient);
  private readonly apis = inject(AppApis);
  read(workflowId: number) {
    return this.http.get<WorkflowAutomatedActivitiesRead>(
      this.apis.core.manual.platformWorkflowAutomatedActivities(workflowId),
      { headers, withCredentials: true },
    );
  }
  control(
    workflowId: number,
    run: WorkflowAutomatedActivityRun,
    action: 'cancel' | 'restart',
    reason: string,
    key: string,
  ) {
    return this.http.post<WorkflowAutomatedActivitiesRead>(
      `${this.apis.core.manual.platformWorkflowAutomatedActivities(workflowId)}/${encodeURIComponent(run.invocationId)}/${action}`,
      { reason, occurrenceId: run.occurrenceId },
      {
        withCredentials: true,
        headers: headers
          .set('If-Match', run.workflowETag)
          .set('Idempotency-Key', key),
      },
    );
  }
}
